import { render, staticRenderFns } from "./BannerFooter.vue?vue&type=template&id=26a12274&scoped=true"
import script from "./BannerFooter.vue?vue&type=script&lang=js"
export * from "./BannerFooter.vue?vue&type=script&lang=js"
import style0 from "./BannerFooter.vue?vue&type=style&index=0&id=26a12274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a12274",
  null
  
)

export default component.exports